import { useState, useEffect } from "react";
import { useReveal } from "./useReveal";

export function useCountUp(target: number, duration = 1400) {
  const { ref, visible } = useReveal(0.2);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!visible) return;
    const startTime = Date.now();
    const frame = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(target * eased));
      if (progress < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  }, [visible, target, duration]);

  return { ref, count };
}
